<template>
  <div class="products-list-page">
    <!-- 页面标题区域 -->
    <product-head></product-head>

    <!-- 酶类产品展示组件-->
    <BRList v-if="category===1" @getSelectedCategory="getSelectedCategoryId" :parentId="parentId" :current-page="currentPage" @pageChange="handlePageChange" :selectedCategory="selectedCategory" :total="total" :products="filteredProducts"></BRList>

    <!-- 化学试剂列表展示组件-->
    <CRList v-else @getSelectedCategory="getSelectedCategoryId" :current-page="currentPage" @pageChange="handlePageChange" :selectedCategory="selectedCategory" :total="total" :products="filteredProducts"></CRList>
  </div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getProductPageList, getProductCenterList } from '@/api/products'
import {mapState} from "vuex";
import Pagination from '@/components/Pagination.vue'
import BRList from './BiochemicalReagent.vue'
import CRList from './ChemicalReagent.vue'
import {getEnzyme} from "@/api/menu";
import {pushWithLanguage} from "@/utils/routeUtils";
import productHead from "@/views/product/productHead.vue";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductsList',
  components: {
    productHead,
    BRList,
    CRList,
    Pagination
  },

  data() {
    return {
      searchKeyword: '',
      categories: [], // 所有分类数据
      selectedCategory: '',
      category: null,
      categoryInfo: null,
      currentPage: 1,
      pageSize: 10,
      total: 100,
      loading: false,
      products: [],
      parentId: '',
      categoryList: [],
      productQuery: {
        productId: '',
        name: '',
        parentId: '',
        parentName: ''
      }
    }
  },

  computed: {
    filteredProducts() {
      let result = this.products
      if (this.selectedCategory) {
        // 分类过滤逻辑
      }
      return result
    },
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },

  watch: {
    '$route'(to, from) {
      this.getCategoryList(this.$route.params.id)
    },
    selectedCategory: {
      handler(newVal, oldVal) {
        // 监听分类变化，重新加载产品列表
        this.loadProducts()
      },
      immediate: true
    },
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 加载产品数据
          this.loadProducts()
        }
      },
      immediate: false
    }
  },

  created() {
    this.getCategoryList(this.$route.params.id)
  },

  mounted() {
    this.initAnimations()
  },

  methods: {
    //获取子组件 SelectedCategory
    getSelectedCategoryId(id) {
      this.selectedCategory = id
      this.currentPage = 1
      this.loadProducts()
    },

    // 判断函数
    isInCategoryList(id) {
      const whitelist = this.categoryList
      return whitelist.includes(id);
    },

    //获取生物试剂的列表
    async getCategoryList(productId) {
      const res = await getEnzyme()
      if (res.success) {
        this.categoryList = res.data
        this.selectedCategory = productId
        if (this.isInCategoryList(this.selectedCategory)) {
          this.parentId = this.$route.params.id
          this.category = 1
        } else {
          this.category = null
        }
      } else {
        this.$message.error(res.msg)
      }
    },

    loadProducts() {
      if(Number(this.category) === 1){
        this.getBrData()
      }else{
        this.getCrData()
      }
    },


    //化学世界数据处理
    async getCrData() {
      this.loading = true
      try {
        // 构建查询参数
        const params = {
          productTypeId: this.selectedCategory,
          keyword: this.searchKeyword
        }

        const response = await getProductPageList(params, {
          current: this.currentPage,
          size: this.pageSize
        })

        if (response.success) {
          this.products = response.data.records
          this.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取产品列表失败')
        }
      } catch (error) {
        console.error('加载产品失败:', error)
        this.$message.error('加载产品失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },


    //酶类数据处理
    async getBrData() {
      this.loading = true
      try {
        // 构建查询参数
        const params = {
          productTypeId: this.selectedCategory,
          category: this.productQuery.category,
          keyword: this.searchKeyword
        }
        const response = await getProductPageList(params, {
          current: this.currentPage,
          size: this.pageSize
        })

        if (response.success) {
          this.products = response.data.records
          // this.module = this.products?this.products.filter(item => item.module? item : null)[0].module.content : []//获取包含module的对象
          this.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取产品列表失败')
        }
      } catch (error) {
        console.error('加载产品失败:', error)
      } finally {
        this.loading = false
      }

    },

    handleProductClick(product) {
      pushWithLanguage(`/products/${product.id}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error( err)
        }
      })
    },

    handlePageChange(page) {
      this.currentPage = page
      this.loadProducts()
    },

    initAnimations() {
      // 页面标题动画
      gsap.from('.page-title, .breadcrumb', {
        y: 30,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/styles/variables.less';
@import '@/assets/styles/mixins.less';

.products-list-page {
}
</style> 